import type { LoaderFunctionArgs } from 'react-router-dom'
import { getContainersProducts } from 'client/stock-transfers/stock-transfers.client'

export const productsLoader = async ({ params }: LoaderFunctionArgs) => {
  const rawOrderContainers = localStorage.getItem('orderContainersAtom')
  const orderContainers: string[] = rawOrderContainers
    ? JSON.parse(rawOrderContainers)
    : []

  return await getContainersProducts(
    `${params.transferId}`,
    orderContainers.join(',')
  )
}
